import React from 'react';
import { SvgIcon } from '@material-ui/core';

const CaretUpIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 8 6">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.994342 0.5H7.00566C7.55482 0.5 8 0.948268 8 1.50124C8 1.76845 7.89392 2.02458 7.70537 2.21261L4.69972 5.21014C4.31219 5.59662 3.68781 5.59662 3.30028 5.21014L0.294625 2.21261C-0.0955522 1.82349 -0.0985797 1.18955 0.287863 0.796668C0.474606 0.606813 0.728969 0.5 0.994342 0.5Z"
      fill="#0D004D"
    />
  </SvgIcon>
);

export default CaretUpIcon;
